export default {"src":"/_next/static/media/inovando-horizontal-negativo.39fbd6a0.svg","height":63,"width":311};